import {
  HEALTH_INSURER_LIST_REQUEST,
  HEALTH_INSURER_LIST_RECEIVED,
  HEALTH_INSURER_LIST_ERROR,
  HEALTH_INSURER_LIST_SET_PAGE,
  HEALTH_INSURER_LIST_UNLOAD,
  HEALTH_INSURER_SINGLE_FETCH_REQUEST,
  HEALTH_INSURER_SINGLE_FETCH_SUCCESS,
  HEALTH_INSURER_SINGLE_UPDATE_REQUEST,
  HEALTH_INSURER_SINGLE_UPDATED,
  HEALTH_INSURER_SINGLE_UNLOAD,
} from '../constants';

import { hydraPageCount } from '../../helper/apiUtils';

const reducer = (
  state = {
    healthInsurers: [],
    isFetchingHealthInsurers: false,
    currentPage: 1,
    pageCount: null,
    healthInsurer: null,
    isFetchingHealthInsurer: false,
    isUpdatingHealthInsurer: false,
  },
  action,
) => {
  switch (action.type) {
    case HEALTH_INSURER_LIST_UNLOAD:
      return {
        ...state,
        healthInsurers: [],
        isFetchingHealthInsurers: false,
        currentPage: 1,
        pageCount: null,
      };

    case HEALTH_INSURER_LIST_REQUEST:
      return {
        ...state,
        isFetchingHealthInsurers: true,
      };

    case HEALTH_INSURER_LIST_RECEIVED:
      return {
        ...state,
        healthInsurers: action.data['hydra:member'],
        pageCount: hydraPageCount(action.data),
        isFetchingHealthInsurers: false,
      };

    case HEALTH_INSURER_LIST_ERROR:
      return {
        ...state,
        isFetchingHealthInsurers: false,
      };
    case HEALTH_INSURER_LIST_SET_PAGE:
      return {
        ...state,
        currentPage: action.page,
      };

    case HEALTH_INSURER_SINGLE_UNLOAD:
      return {
        ...state,
        healthInsurer: null,
        isFetchingHealthInsurer: false,
        isUpdatingHealthInsurer: false,
      };

    case HEALTH_INSURER_SINGLE_FETCH_REQUEST:
      return {
        ...state,
        isFetchingHealthInsurer: true,
      };

    case HEALTH_INSURER_SINGLE_FETCH_SUCCESS:
      return {
        ...state,
        healthInsurer: action.data,
        isFetchingHealthInsurer: false,
      };

    case HEALTH_INSURER_SINGLE_UPDATE_REQUEST:
      return {
        ...state,
        isUpdatingHealthInsurer: true,
      };

    case HEALTH_INSURER_SINGLE_UPDATED:
      return {
        ...state,
        healthInsurer: action.data,
        isUpdatingHealthInsurer: false,
      };

    default:
      return state;
  }
};

export default reducer;
